<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { home } from '@/routes';
import { localHref } from '@/lib/localHref';

defineProps<{
    title?: string;
    description?: string;
}>();
</script>

<template>
    <div
        class="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10"
    >
        <div class="w-full max-w-sm">
            <div class="flex flex-col gap-8">
                <div class="flex flex-col items-center gap-4">
                    <Link
                        :href="localHref(home())"
                        class="flex flex-col items-center gap-2 font-medium"
                    >
                        <img
                            src="/assets/app/logos/logo-dark.3afd2a7545dd.png"
                            alt="ProExpert"
                            class="mb-1 h-9 w-auto dark:hidden"
                        />
                        <img
                            src="/assets/app/logos/logo-light.0fb850e2b68d.png"
                            alt="ProExpert"
                            class="mb-1 hidden h-9 w-auto dark:block"
                        />
                    </Link>
                    <div class="space-y-2 text-center">
                        <h1 class="text-xl font-medium">{{ title }}</h1>
                        <p class="text-center text-sm text-muted-foreground">
                            {{ description }}
                        </p>
                    </div>
                </div>
                <slot />
            </div>
        </div>
    </div>
</template>
